export default () => ({

    show: false,
    showBanner: false,

    init() {

        let cookie = this.getCookie('USER_COOKIE_CONSENT');

        if (cookie !== "")
        {
            this.show = false;
        } else {
            this.show = true;
        }

        setTimeout(()=> {
            this.showBanner = true;
        }, 300)
    },


    accept() {

        this.deleteCookie('USER_COOKIE_CONSENT');
        this.setCookie('USER_COOKIE_CONSENT', 1, 30);
        this.show = false;
        
        location.reload();
    },

    decline() {

        this.deleteCookie('USER_COOKIE_CONSENT');
        this.setCookie('USER_COOKIE_CONSENT', 0, 30);
        this.show = false;

        location.reload();
        
    },

    getCookie(cookieName) {
        let name = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },


    setCookie(cookieName, cookieValue, expiresInDays) {
        const d = new Date();
        d.setTime(d.getTime() + (expiresInDays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    },


    deleteCookie(cookieName) {
        const d = new Date();
        d.setTime(d.getTime() + (24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cookieName + "=;" + expires + ";path=/";
    },
});
